import React, { useEffect, useState } from "react";
import { Container, Grid } from "@mantine/core";
import { TopListTable } from "./topLitTable";

const SupplierDashboard = ({ data, selectedBadge, setSelectedBadge }) => (
  <Container
    style={{ marginTop: "10px", marginLeft: "0px", maxWidth: "1200px" }}
  >
    <Grid>
      <Grid.Col span={4}>
         
        <TopListTable
          data={data?.top_supplier_businesses || []}
          title="Top Businesses"
          selectedBadge={selectedBadge}
          setSelectedBadge={setSelectedBadge}
          headers={["Name", "Orders", "Sales"]}
          dataKeys={["business_name", "total_orders", "total_sales"]}
          nameKey="business_name"
        />
      </Grid.Col>
      <Grid.Col span={4}>
        <TopListTable
          data={data?.top_warehouses || []}
          title="Top Warehouses"
          headers={["Name", "Orders", "Sales"]}
          dataKeys={["name", "total_orders", "total_sales"]}
          selectedBadge={selectedBadge}
          setSelectedBadge={setSelectedBadge}
        />
      </Grid.Col>
      <Grid.Col span={4}>
        <TopListTable
          data={data?.top_products || []}
          title="Top Products"
          headers={["Name", "Orders", "Sales"]}
          dataKeys={["name", "total_orders", "total_sales"]}
          selectedBadge={selectedBadge}
          setSelectedBadge={setSelectedBadge}
        />
      </Grid.Col>
    </Grid>
  </Container>
);

export default SupplierDashboard;
